import {useTranslation} from "react-i18next";
import React, {useState} from "react";
import SweetAlert from "react-bootstrap-sweetalert";

const useDeleteConfirmation = () => {
  const { t } = useTranslation();
  const defaultProps = {show: false}
  const [deleteConfirmationProps, setDeleteConfirmationProps] = useState(defaultProps)

  const confirm = (confirmValue, callback) => {
    setDeleteConfirmationProps(prevProps => ({...prevProps, show: true, confirmValue: confirmValue, onConfirm: () => {
        callback()
        resetProps()
      }}))
  }

  const resetProps = () => {
    setDeleteConfirmationProps(defaultProps)
  }

  const DeleteConfirmation = ({placeholder, show, onConfirm, onCancel, confirmValue}) => {
    return <>{show && <SweetAlert input
                                  showCancel
                                  title={t("confirm?")}
                                  confirmBtnText={t("delete")}
                                  confirmBtnBsStyle="danger"
                                  cancelBtnText={t("cancel")}
                                  cancelBtnBsStyle="light"
                                  onConfirm={(value) => value === confirmValue && onConfirm()}
                                  placeholder={placeholder}
                                  onCancel={onCancel}>
      {t("irreversible")}
      <hr/>
    </SweetAlert>}</>
  }

  return {DeleteConfirmation, deleteConfirmationProps: {...deleteConfirmationProps, onCancel: resetProps}, confirm}
}

export default useDeleteConfirmation
